import React, { useState } from "react";
import "./GuesthouseContent.css";

const BOOKING_REQUEST_SUBBUTTONS = [
  { label: "Booking Request", target: "/guesthouse/booking-request-admin", enabled: true },
  { label: "Booking Request(by Mobile)", target: null, enabled: false },
  { label: "Change Request", target: "/guesthouse/change-request", enabled: true },
];

export default function GuesthouseAdminPanel({ onNavigate }) {
  const [showBookingMenu, setShowBookingMenu] = useState(false);

  const adminButtons = [
    { label: "Pending Bookings", target: "RptBookingStatusAdminFromDate", colorClass: "emp-btn-blue" },
    { label: "Room Logbook", target: "RptRoomLogbook", colorClass: "emp-btn-pink" },
    { label: "CheckIn-CheckOut", target: "RptLogBookRecord", colorClass: "emp-btn-green" },
    { label: "Tariff", target: "/guesthouse/tariff", colorClass: "emp-btn-slate" },
    { label: "Booking Request", target: null, colorClass: "emp-btn-emerald" },
    { label: "Rooms", target: "RptRoomListGuestHouseWise", colorClass: "emp-btn-pink" },
    { label: "Pending Verifications", target: "PendingVerificationsEmployees", colorClass: "emp-btn-blue" },
    { label: "Departments", target: "/members-list", colorClass: "emp-btn-indigo" },
    { label: "MembersList", target: "/fellows-list", colorClass: "emp-btn-coral" },
    { label: "CollegeTeachersList", target: "/college-teachers-list", colorClass: "emp-btn-blue" },
    { label: "Individual Ledger", target: "/individual-ledger", colorClass: "emp-btn-purple" },
    { label: "SMS Logs", target: "FormSMSLogs", colorClass: "emp-btn-slate" },
    { label: "Invoice Details", target: "/guesthouse/invoice-details", colorClass: "emp-btn-emerald" },
    { label: "Payment Details", target: "RptPaymentDetails", colorClass: "emp-btn-green" },
    { label: "New Member", target: "NewMember", colorClass: "emp-btn-indigo" },
    { label: "Departmental Roles", target: "/departmental-roles", colorClass: "emp-btn-green" },
    { label: "Departments/Centres", target: "Infra/ViewFacultyDepartments", colorClass: "emp-btn-blue" },
    { label: "Directory", target: "Directory/FormEmpList", colorClass: "emp-btn-purple" },
    { label: "Holiday List", target: "Holidays/RptHolidays", colorClass: "emp-btn-pink" },
    { label: "Switch Roles", target: "BasicRoles", colorClass: "emp-btn-indigo" },
    { label: "Logout", target: "Logout", colorClass: "emp-btn-slate" },
  ];

  return (
    <div>
      <div className="emp-admin-btn-wrap">
        {adminButtons.map((item) => (
          <button
            key={item.label}
            type="button"
            className={`emp-admin-btn ${item.colorClass}`}
            onClick={() => {
              if (item.label === "Booking Request") {
                setShowBookingMenu((prev) => !prev);
                return;
              }
              if (onNavigate) {
                onNavigate(item.target);
              }
            }}
          >
            <span>{item.label}</span>
          </button>
        ))}
      </div>

      {showBookingMenu && (
        <div className="emp-admin-btn-wrap emp-admin-submenu-wrap">
          {BOOKING_REQUEST_SUBBUTTONS.map((item) => (
            <button
              key={item.label}
              type="button"
              className="emp-admin-btn emp-btn-emerald"
              disabled={!item.enabled}
              title={item.enabled ? "" : "Coming soon"}
              onClick={() => {
                if (item.enabled && onNavigate) {
                  onNavigate(item.target);
                }
              }}
            >
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}